import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in

    useEffect(() => {
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(false));
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        setUser(data);
        return data;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch (e) {}
        setUser(false);
    };

    const refreshUser = async () => {
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
            return data;
        } catch (e) {
            setUser(false);
            return false;
        }
    };

    return (
        <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshUser, formatApiError }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
